<template>
    <div class="sticky-wrapper">
        <no-transition-messages :messages="messages"></no-transition-messages>              
    </div>
</template>

<script>
    import Vue from 'vue';
    import NoTransitionMessages from './no-transition-messages'
    Vue.component('no-transition-messages', NoTransitionMessages);
    export default {
        data() {
            return {
                
            }
        },
        props:{
            messages: {
            }
        },
        mounted() {
            
        }
    }
</script>
<style>
    .sticky-wrapper {
        height:200px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        text-align: center;        
    }

    @media only screen and (min-width: 1000px) and (orientation:portrait), screen and (min-width:1500px) and (orientation:landscape) {
        .sticky-wrapper {
            margin-top: 15px;
            height: 235px;
        }
    }
</style>
